import React, { useState } from "react";
import styled from "styled-components";
import content from "../../content";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getCart,
    getSelectedAttributes,
} from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import AlertDialog from "../../components/Dialogs/AlertDialog";
import { Price, Button } from "../Page/Creator";
import { SummaryExpander } from "./SummaryExpander";

const Wrapper = styled.div`
  width: 25%;
  height: calc(100% - 61px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ButtonWrapper = styled.div`
  width: 100%;
`;

const PriceWrapper = styled.div`
  width: 100%;
  height: 60px;
  font-size: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dedede;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  font-size: 18px;
`;

const GridItem = styled.div`
  padding: 20px 20px 0px 15px;
`;

const GridItemPrice = styled.div`
  padding: 20px 15px 0px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #dedede;
`;

function Components({ style, to, validate }: IComponents) {
    const [openDialog, setOpenDialog] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const dispatch = useDispatch();

    const cart = useSelector(getCart);
    const openResetDialog = () => setOpenDialog(true);
    const closeDialog = () => setOpenDialog(false);
    const reset = () => dispatch({ type: ProjectActions.Reset });
    return (
        <Wrapper style={style}>
            <div>
                {cart.map((p) => (
                    <div key={p.id}>
                        <SummaryExpander
                            expanded={p.id === expanded}
                            setExpanded={setExpanded}
                            project={p}
                        ></SummaryExpander>
                    </div>
                ))}
            </div>
            <div>
                <Price
                    anyPrice={
                        cart.length === 0
                            ? 0
                            : cart
                                .reduce(
                                    (a, b: any) =>
                                        a.concat(
                                            b.components.map((c: any) => ({
                                                ...c,
                                                price: Number(c.price) * b.count,
                                            }))
                                        ),
                                    []
                                )
                                .reduce(
                                    (a, b: any) => (Number(a) + Number(b.price)).toFixed(2),
                                    ""
                                )
                    }
                />
                <ButtonWrapper>
                    <Button
                        onClick={validate}
                        label={content.getValue("go_next")}
                    ></Button>

                    {/*<Button*/}
                    {/*  onClick={validate}*/}
                    {/*  disabled={selected.length === 0}*/}
                    {/*  style={{*/}
                    {/*    borderRadius: "unset",*/}
                    {/*    height: "45px",*/}
                    {/*    width: noReset ? "100%" : "75%",*/}
                    {/*  }}*/}
                    {/*  disableElevation={true}*/}
                    {/*  endIcon={<ChevronRight />}*/}
                    {/*  variant={"contained"}*/}
                    {/*  color={"primary"}*/}
                    {/*>*/}
                    {/*  {content.getValue("place_order")}*/}
                    {/*</Button>*/}
                </ButtonWrapper>
            </div>
        </Wrapper>
    );
}

export interface IComponents {
    style?: React.CSSProperties;
    validate?: () => void;
    to: string;
}

export default Components;
